(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const backBtn = document.getElementById("globalBackBtn");
    if (!backBtn) return;

    const currentUrl = window.location.pathname + window.location.search;
    let historyStack = JSON.parse(sessionStorage.getItem("historyStack") || "[]");

    // ================= История =================
    if (!sessionStorage.getItem("backNavigation")) {
      if (!sessionStorage.getItem("firstLoadDone")) {
        historyStack = [currentUrl];
        sessionStorage.setItem("firstLoadDone", "1");
      } else if (historyStack[historyStack.length - 1] !== currentUrl) {
        historyStack.push(currentUrl);
      }
      sessionStorage.setItem("historyStack", JSON.stringify(historyStack));
    } else {
      sessionStorage.removeItem("backNavigation");
    }

    // ================= Модалки =================
    function isModalOpen() {
      return !!(
        document.querySelector('.modal[data-modal-state="open"]') ||
        document.querySelector('.__inset.__inset_show') ||
        document.querySelector('body > div.__inset.__inset_show')
      );
    }

    function closeTopModal() {
      const openModal = document.querySelector('.modal[data-modal-state="open"], .__inset.__inset_show, body > div.__inset.__inset_show');
      if (openModal) {
        openModal.classList.remove('__inset_show');
        openModal.removeAttribute('data-modal-state');
      }
      updateBackButton();
    }

    // ================= Обновление кнопки =================
    function updateBackButton() {
      if (!backBtn) return;
      historyStack = JSON.parse(sessionStorage.getItem("historyStack") || "[]");

      const hasSameOriginReferrer = (() => {
        try {
          if (!document.referrer) return false;
          const refUrl = new URL(document.referrer);
          return refUrl.origin === window.location.origin && (refUrl.pathname + refUrl.search) !== (window.location.pathname + window.location.search);
        } catch (e) {
          return false;
        }
      })();

      // Показываем кнопку, если есть куда вернуться ИЛИ открыта модалка (чтобы можно было закрыть)
      if (historyStack.length > 1 || isModalOpen() || hasSameOriginReferrer) {
        backBtn.classList.add("is-visible");
      } else {
        backBtn.classList.remove("is-visible");
      }
    }

    // ================= Клик по кнопке =================
    backBtn.addEventListener("click", () => {
      if (isModalOpen()) {
        closeTopModal();
        return;
      }

      historyStack = JSON.parse(sessionStorage.getItem("historyStack") || "[]");
      if (historyStack.length > 1) {
        const prev = historyStack[historyStack.length - 2];
        historyStack.pop();
        sessionStorage.setItem("historyStack", JSON.stringify(historyStack));
        sessionStorage.setItem("backNavigation", "1");
        window.location.href = prev;
      } else {
        // Fallback: если истории нет (переход с внешнего источника / прямой вход)
        try {
          if (document.referrer) {
            const refUrl = new URL(document.referrer);
            if (refUrl.origin === window.location.origin) {
              window.location.href = document.referrer;
              return;
            }
          }
        } catch (e) {
          // игнорируем
        }
        const fallback = backBtn.dataset.fallback || "/";
        window.location.href = fallback;
      }
    });

    // ================= Наблюдатель за модалками =================
    if (window.MutationObserver) {
      const observer = new MutationObserver(() => updateBackButton());
      document.querySelectorAll('.modal, .__inset, body > div.__inset').forEach(el => {
        observer.observe(el, { attributes: true, attributeFilter: ['class', 'data-modal-state'] });
      });
    }

    // ================= Инициализация =================
    updateBackButton();
    document.addEventListener("click", updateBackButton, true);
    window.addEventListener("load", updateBackButton);
  });
})();


